<template>
  <input
    :class="getClass"
    :name="name"
    :placeholder="getPlaceholder"
    :type="type"
    :value="getValue"
    v-cleave="getMask"
    @blur="onBlur"
    @focus="onFocus"
    @input="onInput"
    @keydown.enter="onEnter"/>
</template>

<script>
import { FormElement } from '@/mixins'

export default {
  name: 'BaseInput',

  mixins: [FormElement],

  props: {
    creditCard: Boolean,
    mask: String,
    monthYear: Boolean,
    numeric: Boolean,
    type: {
      default: 'text',
      type: String
    },
    value: [Number, String]
  },

  computed: {
    getMask () {
      if (this.mask === 'credit-card' || this.creditCard) {
        return {
          creditCard: true,
          onCreditCardTypeChanged: (type) => this.$emit('creditCardType', type)
        }
      }

      if (this.mask === 'month-year' || this.monthYear) {
        return { date: true, datePattern: ['m', 'y'] }
      }

      if (this.mask === 'numeric' || this.numeric) {
        return { numeral: true, numeralThousandsGroupStyle: 'thousand' }
      }

      return {}
    }
  }
}
</script>
